import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./AllComponents/App/store"; // Ensure this import path is correct
// import { ReactQueryProvider } from "./Provider";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

let persistor: any = persistStore(store);

root.render(
  // <React.StrictMode>
  <BrowserRouter basename={"/"}>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        {" "}
        <App />
      </PersistGate>
    </Provider>
  </BrowserRouter>
  // </React.StrictMode>
);

reportWebVitals();
